<template>
  <v-container
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="primary"
          title="Actualités"
          text="Liste des actualités"
        >
          <v-card-title>
            <v-btn
              class="mx-0 font-weight-light"
              color="primary"
              @click="showModal('Addactualite')"
            >
              Ajouter une Actualité
            </v-btn>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Recherche"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="actualites"
            :search="search"
          >

            <template v-slot:item.publie="{ item }">
              <v-icon
                v-if="item.publie"
                color="primary"
              >
                mdi-eye
              </v-icon>
              <v-icon
                v-else
                color="primary"
              >
                mdi-eye-off
              </v-icon>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                v-ripple
                color="warning"
                style="cursor: pointer; border-radius: 10em; padding: 2px;"
                @click="actionItem(item.id, 'edit')">mdi-pencil</v-icon>
              <v-icon
                v-ripple
                color="red"
                style="cursor: pointer; border-radius: 10em; padding: 2px;"
                @click="actionItem(item.id, 'delete')">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <functions-addactualite/>
    <functions-editactualite/>
    <functions-deleteactualite/>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex'
import { db } from '@/plugins/firebase'

export default {
  data: () => ({
    search: '',
    headers: [
      {
        sortable: true,
        text: 'Publié',
        value: 'publie'
      },
      {
        sortable: true,
        text: 'Date création',
        value: 'creation'
      },
      {
        sortable: true,
        text: 'Date début',
        value: 'datestart'
      },
      {
        sortable: true,
        text: 'Date fin',
        value: 'dateend'
      },
      {
        sortable: true,
        text: 'Titre',
        value: 'titre'
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'right'
      }
    ]
  }),
  computed: {
    ...mapGetters(['actualites'])
  },
  created () {
    this.$store.dispatch('bindActualites')
  },
  methods: {
    actionItem (actualiteToFetch, action) {
      db.collection('actualites').doc(actualiteToFetch).get()
        .then(doc => {
          const datasToFetch = doc.data()
          datasToFetch.id = actualiteToFetch
          this.$store.dispatch('fetchSelectedActualite', datasToFetch)
          if (action === 'edit') {
            this.showModal('Editactualite')
          } else if (action === 'delete') {
            this.showModal('Deleteactualite')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ...mapActions(['showModal'])
  }
}
</script>
